export default __webpack_public_path__ + "static/media/sun.98c9269e.svg";